import { TableViewStore, BaseListViewStore, DateRangeQueryPickerStore, QueryPickerStore } from "core/stores";
import { FacilityOrderService } from "application/facility-order/services";
import { ImportService } from 'application/import/services';
import { PersonService } from 'application/person/services';
import { BaasicDropdownStore } from 'core/stores'
import _ from 'lodash';
import { toDate, isDeveloper } from 'core/utils';
import { FacilityService } from "application/facility/services";
import { ScheduleService } from "application/schedule/services";
import { action, observable } from 'mobx';

class FacilityOrderListNewFlowViewStore extends BaseListViewStore {
	@observable accessor counter = 0;
	constructor(rootStore) {
        const facilityOrderService = new FacilityOrderService(rootStore.application.baasic.apiClient);
        const importService = new ImportService(rootStore.application.baasic.apiClient);
        const personService = new PersonService(rootStore.application.baasic.apiClient);
        const facilityService = new FacilityService(rootStore.application.baasic.apiClient);
        const scheduleService = new ScheduleService(rootStore.application.baasic.apiClient);
        super(rootStore, {
			autoInit: true,
			name: 'facility-order',
			routes: {
				edit: id => {
					window.open(this.rootStore.routerStore.findRoute('master.app.main.facility.edit').pattern.replace(":id", id));
				},
				facilityPreview: id => {
					window.open(this.rootStore.routerStore.findRoute('master.app.main.facility.preview').pattern.replace(":id", id));
				},
				create: () => {
					this.rootStore.routerStore.goTo("master.app.main.facility-order.create");
				},
				createCsv: () => {
					this.rootStore.routerStore.goTo("master.app.main.facility-order.create-csv");
				},
				orderingCalendar: async item => {
					const typeResponse = await scheduleService.getTypes();
					var calendarType = _.find(typeResponse.item, { abrv: 'ordering' });
					let intakeRep = item.intakeRepId ? `intakeRepId=${item.intakeRepId}&` : '';
					window.open(`${this.rootStore.routerStore.findRoute("master.app.main.schedule.calendar").pattern}?${intakeRep}calendarTypeId=${calendarType.id}&facilityId=${item.facilityId}`);
				},
				deliveryCalendar: async item => {
					const typeResponse = await scheduleService.getTypes();
					var calendarType = _.find(typeResponse.item, { abrv: 'delivery' });
					let intakeRep = item.intakeRepId ? `intakeRepId=${item.intakeRepId}&` : '';
					window.open(`${this.rootStore.routerStore.findRoute("master.app.main.schedule.calendar").pattern}?${intakeRep}&calendarTypeId=${calendarType.id}&facilityId=${item.facilityId}`);
				}
			},
			actions: () => {
				return {
					find: async params => {
						if (this.counter === 0) {
							this.counter++;
							if (this.queryUtility.filter.userRepId === undefined && !isDeveloper(this.rootStore.userStore.user.userName)) {
                                const response = await personService.getByUser(this.rootStore.userStore.applicationUser.id);

                                if (response) {
                                    this.queryUtility.filter.set('userRepId', response.data.id);
                                    params.userRepId = response.data.id;
                                }
							}
						}

						const response = await facilityOrderService.find(_.extend({ isNiko: false, isNewFlow2: true, ...params }, {
							embed: 'CoreUser,Facility,FacilityOrderStatuses,Facility.FacilityAreaOfCares,Facility.IntakeRep,ImportHeaderStatus,NextOrderingDate,NextDeliveryDate',
						}));
						const responseData = _.extend(response.data, {
							item: _.map(response.data.item, (item => {
								return _.extend(
									item, {
									facility: item.facility && item.facility.name,
									facilityAreaOfCares: item.facility && item.facility.facilityAreaOfCares,
									intakeRep: item.facility && item.facility.intakeRep && item.facility.intakeRep.fullName,
									intakeRepId: item.facility && item.facility.intakeRepId,
									nextOrderingDate: item.nextOrderingDate && toDate(item.nextOrderingDate),
									status: item.importHeaderStatus && item.importHeaderStatus.name && `${item.importHeaderStatus.name == "Imported" ? (item.isStatusCompleted ? "Order" : "Billing") : item.importHeaderStatus.name}${item.importHeaderStatus.name !== 'New' && item.importHeaderStatus.name !== 'Reviewed' && item.importHeaderStatus.name !== 'Processing' ? item.isStatusCompleted ? ' Complete' : ' in Progress' : ''}`,
									dateCreated: toDate(item.dateCreated),
									dateOfService: item.dateOfService && toDate(item.dateOfService),
								}
								);
							}))
						});
						return responseData;
					},
					delete: async item => {
						return await facilityOrderService.delete({ id: item.id });
					},
				};
			},
		});

        this.importStatusStore = new BaasicDropdownStore({}, {
			fetchFunc: async () => {
				const response = await importService.getStatus();
				return response.item;
			}
		});

        this.nextDeliveryDatePickerStore = new QueryPickerStore();
        this.nextOrderingDatePickerStore = new QueryPickerStore();
        this.createdAtPickerStore = new QueryPickerStore();
        this.dateOfServicePickerStore = new QueryPickerStore();

        this.personStore = new BaasicDropdownStore({
			filterable: true
		}, {
			fetchFunc: async (term) => {
				const response = await personService.find({ searchQuery: term, rpp: 200, isActive: true });
				return _.map(response.data.item, item => {
					return {
						id: item.id,
						name: item.firstName + ' ' + item.lastName
					};
				});
			}
		});

        this.facilityStore = new BaasicDropdownStore({
			filterable: true
		},
			{
				fetchFunc: async (term) => {
					const response = await facilityService.find({ searchQuery: term, rpp: 100 });
					return _.map(response.data.item, item => {
						return {
							id: item.id,
							name: item.name,
							isNiko: item.isNiko
						};
					});
				}
			});

        this.rangeQueryPickerStore = new DateRangeQueryPickerStore();

        this.queryUtility.onResetFilter = () => {
			this.facilityStore.setValue(null);
			this.facilityStore.filterTerm = "";

			this.importStatusStore.setValue(null);

			this.personStore.setValue(null);
			this.personStore.filterTerm = "";

			this.nextDeliveryDatePickerStore.reset();
			this.nextOrderingDatePickerStore.reset();
			this.createdAtPickerStore.reset();
			this.rangeQueryPickerStore.reset();
			this.dateOfServicePickerStore.reset();
		}

        const userRoles = this.rootStore.userStore.user.roles;
        this.isAdmin = userRoles.includes("Administrators");
        this.isAccountManager = userRoles.includes("AccountManagers");

        this.setTableStore(
			new TableViewStore(this.queryUtility, {
				columns: [
					{
						key: 'facility',
						title: "FACILITY_ORDER.LIST.COLUMNS.FACILITY",
						onClick: item => this.showTemplates(item)
					},
					{
						key: 'intakeRep',
						title: "FACILITY_ORDER.LIST.COLUMNS.INTAKE_SPECIALIST",
						onClick: item => this.showTemplates(item)
					},
					{
						key: 'dateOfService',
						title: "FACILITY_ORDER.LIST.COLUMNS.DATE_OF_SERVICE",
						onClick: item => this.routes.orderingCalendar(item),
						width: 150
					},
					{
						key: 'status',
						title: "FACILITY_ORDER.LIST.COLUMNS.STATUS",
						onClick: item => this.showTemplates(item)
					},
					{
						key: 'dateCreated',
						title: "FACILITY_ORDER.LIST.COLUMNS.BT_RUN_DATE",
						onClick: item => this.showTemplates(item),
						width: 150
					},
				],
				actions: {
					onEdit: item => this.routes.edit(item.facilityId),
					onPreview: (item) => this.routes.facilityPreview(item.facilityId),
					orderingCalendar: (item) => this.routes.orderingCalendar(item),
					onDelete: (this.isAdmin || this.isAccountManager) ? async (item) => this.onDelete(item) : null
				},
			})
		);
    }

	@action.bound
	async onDelete(item) {
		this.rootStore.modalStore.showConfirm(
			'FACILITY_ORDER.LIST.COLUMNS.DELETE_MESSAGE',
			async () => {
				try {
					await this.actions.delete(item);
					this.rootStore.notificationStore.success('FacilityOrder successfully deleted.');
					this.queryUtility.fetch();
				} catch (err) {
					this.rootStore.notificationStore.error(err && err.data && err.data.errors ? err.data.errors : 'An error ocurred while trying to delete Facility Order.');
				}
			}
		);
	}

	@action.bound
	filterOnChange() {
		this.queryUtility.fetch();
	}

	async showTemplates(item) {
		const facilityOrderService = new FacilityOrderService(this.rootStore.application.baasic.apiClient);
		let targetPage = (await facilityOrderService.getTargetPage(item.id)).data;
		targetPage = !targetPage || targetPage == '' ? 'preview' : targetPage == 'order-summary' ? targetPage : targetPage == 'billing' ? targetPage + '.preview' : targetPage + '-preview';
		return window.open(`${this.rootStore.routerStore.findRoute('master.app.main.facility-order.facility-order-new-flow.' + targetPage).pattern.replace(':id', item.id)}`, '_blank');
	}
}

export default FacilityOrderListNewFlowViewStore;